import React from "react";
import { Accordion, Card, Container, Row, Col } from "react-bootstrap";
import t1 from "../../assets/images/t1.png";
import t2 from "../../assets/images/t2.png";
import t3 from "../../assets/images/t3.png";
import t4 from "../../assets/images/t4.png";
import t5 from "../../assets/images/t5.png";
import t6 from "../../assets/images/t6.png";
import t7 from "../../assets/images/t7.png";
import t8 from "../../assets/images/t8.png";
import t9 from "../../assets/images/t9.png";
import b1 from "../../assets/images/c1.png";
import b2 from "../../assets/images/c2.png";
import b3 from "../../assets/images/c3.png";
import b4 from "../../assets/images/c4.png";
import b5 from "../../assets/images/c5.png";
import b6 from "../../assets/images/c6.png";
import b7 from "../../assets/images/c7.png";
import b8 from "../../assets/images/c8.png";
import b10 from "../../assets/images/RaceXbanner1.png";
import b11 from "../../assets/images/RaceXbanner2.png";
import homeLogo from "../../assets/images/RaceXbanner1.png";
import Particle from "../Particle"; 
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";
import rp from "../../assets/images/dcrclogo.png";
import { FaTelegramPlane, FaDiscord, FaTwitter } from "react-icons/fa";
import { Chrono } from "react-chrono";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {Carousel} from '3d-react-carousal';
import ScrollToTop from "../ScrollToTop";
// import AccordionDisplay from "./Accordion";
import Footer from "../Footer";
import ReactPlayer from 'react-player';
import introvid from "../../assets/images/introvid.mp4"; 


function roadmap() {


  return (
    <section>
      <Container fluid className="home-section" id="#">
        <Container className="home-content">
        <Row style={{ justifyContent: "center"}}>
          <Col xl={12} style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <img src={homeLogo} width="100%" className="home-img" alt="home pic"/>
          </Col>
          </Row>
          <Row id="roadmap-section" style={{ justifyContent: "center", paddingTop: "50px", paddingBottom: "20px" }}></Row>
          <div style={{ borderTop: "4px solid red ", marginLeft: 10, marginRight: 10 }}>
          </div>
          <Row style={{ paddingTop: "50px", justifyContent: "center" }}>
            <h1 className="home-heading">
              <strong className="white">RaceX ROADMAP</strong>
            </h1>
          </Row>
          <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}>
            <VerticalTimeline className="custom-line">
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'black', color: 'red', border: ' 2px solid red' }}
                contentArrowStyle={{ borderRight: '7px solid  red' }}
                date=""
                iconStyle={{ background: 'black', color: 'black' }}
                
                
                // icon={<WorkIcon />}
              >
                <h3><strong>October / November 2021</strong></h3>
                <p>
                  Website goes live.<br/>
                  $RACEX token contract has been written.
                </p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'black', color: 'red', border: ' 2px solid red' }}
                contentArrowStyle={{ borderRight: '7px solid  red' }}
                date=""
                iconStyle={{ background: 'black', color: 'black' }}
                
                // icon={<WorkIcon />}
              >
                <h3 className="vertical-timeline-element-title"><strong>Nov 2021</strong></h3>
                <p>
                  NFT Race Cars Series 1, limited amount being produced. These will be reserved by purchasing an NFKey
                </p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'black', color: 'red', border: ' 2px solid red' }}
                contentArrowStyle={{ borderRight: '7px solid  red' }}
                date=""
                iconStyle={{ background: 'black', color: 'black' }}
                // icon={<WorkIcon />}
              >
                <h3 className="vertical-timeline-element-title"><strong>Dec 2021</strong></h3>
                <p>
                NFT Staking - Training, Services, Upgrades
                </p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'black', color: 'red', border: ' 2px solid red' }}
                contentArrowStyle={{ borderRight: '7px solid  red' }}
                date=""
                iconStyle={{ background: 'black', color: 'black' }}
                // icon={<WorkIcon />}
              >
                <h3 className="vertical-timeline-element-title"><strong>Jan 2022</strong></h3>
                <p>
                  Launch of NFT / TT Game - Play to Earn.
                  Launch of V1 Practice Race Simulator.
                </p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                contentStyle={{ background: 'black', color: 'red', border: ' 2px solid red' }}
                contentArrowStyle={{ borderRight: '7px solid  red' }}
                date=""
                iconStyle={{ background: 'black', color: 'black' }}
                // icon={<SchoolIcon />}
              >
                <h3 className="vertical-timeline-element-title"><strong>Feb 2022</strong></h3>
                <p>
                  Launch of Virtual Race Championship Series.<br/>
                  Release of Real world Racing App V1(Race any vehicle across the world)
                </p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                contentStyle={{ background: 'black', color: 'red', border: ' 2px solid red' }}
                contentArrowStyle={{ borderRight: '7px solid  red' }}
                date=""
                iconStyle={{ background: 'black', color: 'black' }}
                // icon={<SchoolIcon />}
              >
                <h3 className="vertical-timeline-element-title"><strong>March 2022</strong></h3>
                <h4 className="vertical-timeline-element-subtitle"></h4>
                <p>
                  Real World race virtualization. Watch realworld races on Virtual Sim. Real work race results fed into Race Sim to produce viewable races. 
                </p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                contentStyle={{ background: 'black', color: 'red', border: ' 2px solid red' }}
                contentArrowStyle={{ borderRight: '7px solid  red' }}
                date=""
                iconStyle={{ background: 'black', color: 'black' }}
                // icon={<SchoolIcon />}
              >
                <h3 className="vertical-timeline-element-title"><strong>April 2022</strong></h3>
                <h4 className="vertical-timeline-element-subtitle"></h4>
                <p>
                  Real vs Virtual. Combine the ability to add Real World race results into Virtual championships and vice versa.
                </p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                contentStyle={{ background: 'black', color: 'red', border: ' 2px solid red' }}
                contentArrowStyle={{ borderRight: '7px solid  red' }}
                date=""
                iconStyle={{ background: 'black', color: 'black' }}
                // icon={<SchoolIcon />}
              >
                <h3 className="vertical-timeline-element-title"><strong>May 2022</strong></h3>
                <h4 className="vertical-timeline-element-subtitle"></h4>
                <p>
                  DCRC.RACING DAO
                  members will be able to vote for enhancements to the platform.
                </p>
              </VerticalTimelineElement>
            </VerticalTimeline>
            {/* <Bullsrm1/> */}
          </Row>


          <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}></Row>
          <Footer />
        </Container>
      </Container>
    </section>
  );
}

export default roadmap;
